import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { StatisticsService } from "../../services/statistics.service";
import {
  IRevenueStatistics,
  ISummaryStatistics,
  StatsRevenuePeriodsEnum,
} from "../../models/Statistics";

export const useGetStatisticSummaryQuery = () => {
  return useQuery<ISummaryStatistics, Error>({
    queryKey: [QUERY_CONSTANTS.GET_STATISTICS_SUMMARY],
    queryFn: () => StatisticsService.getSummary().then((res) => res.data),
  });
};

export const useGetStatisticsRevenueQuery = (period: StatsRevenuePeriodsEnum) => {
  return useQuery<IRevenueStatistics[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_STATISTICS_REVENUE, period],
    queryFn: () => StatisticsService.getRevenue(period).then((res) => res.data),
  });
};
